import { FC, useState } from "react";

import AccordionItem from "./AccordionItem";
import { FAQSectionProps } from "../FAQSection.props";
import styles from "../FAQSection.module.scss";

const FAQMobile: FC<FAQSectionProps> = ({ faqData }: FAQSectionProps) => {
  const [activeFAQItem, setActiveFAQItem] = useState<string>(faqData[0].title);
  return (
    <div className={styles.FAQSectionMobile} data-testid="faq-section-mobile">
      <div className={styles.AccordionWrapper}>
        <div className={styles.AccordionContent}>
          {faqData.map(({ title, content }, index) => (
            <AccordionItem
              key={index}
              title={title}
              content={content}
              isActive={activeFAQItem === title}
              setActiveFAQItem={setActiveFAQItem}
              ariaControls={index}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQMobile;
